export default __webpack_public_path__ + "static/media/270404__littlerobotsoundfactory__jingle-achievement-00.c0ff5302.mp3";